/* eslint-disable react/style-prop-object */
import React from 'react';
import styled from 'styled-components';
import { white } from '@common/styling';
import breakpointsMinWidth from '../../cra/src/styling/breakpointsMinWidth';
import {
  FacebookNew,
  Instagram,
  LinkedInNew,
  TwitterNew,
  WhiteLogo,
} from '../../cra/src/components/userDocuments/editDocument/editJournal/toolset/assets/icons';

const FooterWrapper = styled.footer`
  background-color: #2b1482;
  color: #fff;
  padding: 0 0 72px 0;

  @media ${breakpointsMinWidth.tabletSm} {
    padding: 0 0 32px 0;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding: 0 0 24px 0;
  }
`;

const FooterContainer = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  max-height: none;
  flex-wrap: wrap;
  padding: 44px 20px 0px 20px;

  @media ${breakpointsMinWidth.tabletSm} {
    max-height: 768px;
    padding: 64px 20px 0px 20px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    padding: 64px 108px 0px 108px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    max-height: 584px;
    padding: 64px 108px 0px 108px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    padding: 64px 122px 0px 122px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    padding: 64px 323px 0px 323px;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
`;

const Heading = styled.h4`
  color: #d9e021;
  margin-bottom: 16px;
  font-size: 18px;

  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 20px;
    margin-bottom: 16px;
  }
`;

const Link = styled.a`
  display: block;
  color: #ffffff;
  margin-bottom: 8px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  font-size: 14px;
  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 16px;
    margin-bottom: 4px;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  gap: 32px;
  margin: 44px 0 24px;

  @media ${breakpointsMinWidth.tabletSm} {
    margin: 48px 0 24px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    margin: 32px 0 24px;
  }
`;

const Logo = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 149px;
    height: 32px;
  }
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterContainer>
        <Column className="">
          <Heading>Platform</Heading>
          <Link href="/pricing">Pricing</Link>
          <Link href="/resume-builder">Resume Builder</Link>
          {/* <Link href="#">AI Realistic Interview Preparation</Link> */}
          <Link href="/resume-review">AI Resume Review</Link>
          <Link href="/cover-letter-builder">Cover Letter Builder</Link>
          <Link href="/cover-letter-review">AI Cover Letter Review</Link>
          <Link href="/ai-generated-cover-letter">
            AI Generated Cover Letter
          </Link>
          <Link href="/ai-interview-question-generator">
            AI Interview Question Generator
          </Link>
          <Link href="/linkedIn-builder">AI LinkedIn Builder</Link>
          <Link href="/ai-career-path-guidance">AI Career Path Guidance</Link>
          <Link href="/ai-career-financial-analysis">
            AI Career Financial Analysis
          </Link>
        </Column>

        <Column className="">
          <Heading>Company</Heading>
          <Link href="/about-us/">About</Link>
          <Link href="/privacy-policy/">Privacy & Legal</Link>
          <Link href="/terms-of-use">Terms of Service</Link>
          <Link href="/blogs/">Blogs</Link>
          <Link href="/media-kit/">Media Kit</Link>
          <Link href="/security/">Security</Link>
        </Column>

        <Column className="">
          <Heading>Partnerships</Heading>
          <Link href="/higher-education">Higher Education</Link>
          <Link href="/veterans/">Veterans</Link>
          {/* <Link href="#">Veteran Affairs</Link> */}
          {/* <Link href="#">Companies</Link> */}
          <a
            href="mailto:support@wisedoc.net"
            className="text-white no-underline"
          >
            Contact
          </a>
        </Column>

        <Column className="">
          <Heading>Resume</Heading>
          <Link href="/blogs/what's-ats-how-it-works/">What is an ATS?</Link>
          <Link href="/blogs/beginners-guide-for-writing-a-stunning-resume-in-2021-(updated)/">
            Writing an ATS Friendly Resume
          </Link>
          <Link href="/blogs/how-recruiter-review-your-resume/">
            How Does a Recruiter Review
          </Link>
          <Link href="/blogs/how-create-resume-with-ats-and-recruiter-friendly/">
            Write ATS + Recruiter Friendly Resume
          </Link>
        </Column>

        <Column className="">
          <Heading>Cover Letter</Heading>
          <Link href="/blogs/does-cover-letter-help-job-application/">
            Does a Cover Letter Help?
          </Link>
          <Link href="/blogs/how-wisedoc-instantly-generates-ai-cover-letter-in-20seconds/">
            Cover Letter Generation Using Wisedoc AI
          </Link>
          <Link href="/blogs/generic-vs-job-tailored-cover-letter-what's-real-difference/">
            Generic vs Tailored Cover Letter
          </Link>
          <Link href="/blogs/key-pitfalls-of-cover-letter-writing/">
            Key Pitfalls of Cover Letter
          </Link>
        </Column>

        <Column className="">
          <Heading>Interview</Heading>
          <Link href="/blogs/what-matters-most-for-cracking-interview/">
            What Matters the Most for Cracking an Interview
          </Link>
          <Link href="/blogs/mastering-star-method-for-interview-preparation/">
            STAR Method
          </Link>
          <Link href="/blogs/content-presentation-during-interview-which-matters-more/">
            Content vs Presentation During Interview
          </Link>
          <Link href="/blogs/how-to-answer-any-questions-for-me/">
            Do You Have Any Questions for Me?
          </Link>
        </Column>

        <Column className="">
          <Heading>Career Suites</Heading>
          <Link href="/blogs/wisedoc-ai-career-guidance-to-identify-your-next-job-role/">
            Career Guidance
          </Link>
          <Link href="/blogs/is-ai-going-to-take-my-job/">
            Is AI Going to Take My Job
          </Link>
          <Link href="/blogs/how-much-money-can-i-make-in-my%20role-in-different-states/">
            Understanding Career Financials
          </Link>
          <Link href="/blogs/how-build-an-effective-linkedin-profile/">
            Building an Effective LinkedIn Profile
          </Link>
        </Column>
      </FooterContainer>

      <SocialIcons>
        <a
          href="https://x.com/Wisedoc18"
          target="_blank"
          rel="noopener noreferrer"
        >
          <TwitterNew width="24" height="24" fill={white} />
        </a>
        <a
          href="https://facebook.com/wisedoc2018"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FacebookNew width="24" height="24" fill={white} />
        </a>
        <a
          href="https://linkedin.com/company/wisedoc/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LinkedInNew width="24" height="24" fill={white} />
        </a>
        <a
          href="https://instagram.com/wisedoc.inc/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Instagram width="24" height="24" fill={white} />
        </a>
      </SocialIcons>

      <Logo>
        <WhiteLogo />
      </Logo>
    </FooterWrapper>
  );
};

export default Footer;
